import Icon from '../components/Icon.vue'

Icon.register({
  'smoking-ban': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M96 304C96 312.8 103.2 320 112 320H229.5L133.5 224H112C103.2 224 96 231.2 96 240V304zM256 0C114.6 0 0 114.6 0 256S114.6 512 256 512 512 397.4 512 256 397.4 0 256 0zM256 448C150.1 448 64 361.9 64 256 64 214.6 77.3 176.3 99.7 144.9L367.1 412.3C335.7 434.7 297.4 448 256 448zM301.2 256H384V288H333.2L301.2 256zM412.3 367.1L365.2 320H400C408.8 320 416 312.8 416 304V240C416 231.2 408.8 224 400 224H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64 361.9 64 448 150.1 448 256 448 297.4 434.7 335.7 412.3 367.1zM320.6 128C305 128 292 116.8 289.2 102.1 288.5 98.5 285.2 96 281.5 96H265.3C260.3 96 256.6 100.5 257.3 105.4 261.9 136.3 288.5 160 320.6 160 336.2 160 349.2 171.2 352 185.9 352.7 189.5 356 192 359.7 192H375.9C380.9 192 384.6 187.5 383.9 182.6 379.3 151.7 352.7 128 320.6 128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/smoking-ban.js
// module id = Or0/
// module chunks = 144